/**
 * TikTok 发品库存仓：Create Product inventory.warehouse_id 只能用发货仓，
 * 不能用退货仓（平台 code=12052532 Incorrect shipping warehouse）。
 */

function typeToken(row) {
  return String(
    row?.warehouseType
    || row?.type
    || row?.warehouse_type
    || '',
  ).trim().toUpperCase();
}

/** 是否退货仓（RETURN_WAREHOUSE / 退货仓 / type=2） */
export function isTiktokReturnWarehouse(row) {
  if (!row || typeof row !== 'object') return false;
  const label = String(row.warehouseTypeLabel || '').trim();
  if (label === '退货仓') return true;
  const t = typeToken(row);
  if (!t) return false;
  if (t.includes('RETURN') || t === '2') return true;
  return false;
}

/** 是否发货仓（非退货即视为可发库存仓） */
export function isTiktokSalesWarehouse(row) {
  if (!row || typeof row !== 'object') return false;
  return !isTiktokReturnWarehouse(row);
}

/** 发品/模板下拉：只保留发货仓 */
export function filterTiktokSalesWarehouses(rows) {
  return (Array.isArray(rows) ? rows : []).filter(isTiktokSalesWarehouse);
}
